var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row px-4 sizer"},[_c('div',{staticClass:"col-12",staticStyle:{"padding":"0"}},[_c('Form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }